import type { CanvasGenerationRow, CanvasReferenceItem } from "@/types/canvas"

export const CANVAS_GENERATION_DRAG_TYPE = "application/x-frameriver-canvas-generation"
export const CANVAS_REFERENCE_DRAG_TYPE = "application/x-frameriver-canvas-reference"

export type CanvasGenerationDragPayload = {
  id: number
  url: string
  media_kind: "image" | "video"
  label: string
}

export type CanvasReferenceDragPayload = CanvasReferenceItem

function isValidReferenceDragPayload(ref: CanvasReferenceItem): boolean {
  if (ref.entity_type && ref.entity_id != null) return true
  return Boolean(ref.url?.trim())
}

export function generationToDragPayload(row: CanvasGenerationRow, label: string): CanvasGenerationDragPayload {
  return {
    id: row.id,
    url: row.media_url ?? row.download_url ?? "",
    media_kind: row.media_kind,
    label,
  }
}

export function referenceToDragPayload(ref: CanvasReferenceItem): CanvasReferenceDragPayload {
  return { ...ref }
}

export function dragPayloadToReference(payload: CanvasGenerationDragPayload): CanvasReferenceItem {
  return {
    kind: "entity",
    label: payload.label,
    url: payload.url,
    media_type: payload.media_kind,
    entity_type: "canvas_generation",
    entity_id: payload.id,
  }
}

export function isCanvasDragType(dataTransfer: DataTransfer): boolean {
  return (
    dataTransfer.types.includes(CANVAS_GENERATION_DRAG_TYPE) || dataTransfer.types.includes(CANVAS_REFERENCE_DRAG_TYPE)
  )
}

export function readCanvasReferenceFromDrop(dataTransfer: DataTransfer): CanvasReferenceItem | null {
  const generation = readGenerationDragPayload(dataTransfer)
  if (generation) return dragPayloadToReference(generation)

  const reference = readReferenceDragPayload(dataTransfer)
  if (reference) return reference

  return null
}

export function readGenerationDragPayload(dataTransfer: DataTransfer): CanvasGenerationDragPayload | null {
  const raw = dataTransfer.getData(CANVAS_GENERATION_DRAG_TYPE)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as CanvasGenerationDragPayload
    if (!parsed.url || !parsed.id) return null
    return parsed
  } catch {
    return null
  }
}

export function readReferenceDragPayload(dataTransfer: DataTransfer): CanvasReferenceItem | null {
  const raw = dataTransfer.getData(CANVAS_REFERENCE_DRAG_TYPE)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as CanvasReferenceItem
    if (!isValidReferenceDragPayload(parsed)) return null
    return parsed
  } catch {
    return null
  }
}
